// extracted by mini-css-extract-plugin
export default {"mathEditor":"mathEditor_mathEditor__-RATL","richTextEditor":"mathEditor_richTextEditor__+NXcK"};